import "bootstrap/dist/css/bootstrap.min.css";
import "./css/App.css";

import { Helmet } from "react-helmet";

import ComputerTechnology from "./components/sections/ComputerTechnology/ComputerTechnology";
import BrandingHeader from "./components/sections/BrandingHeader/BrandingHeader";
import TradingHeader from "./components/sections/TradingHeader/TradingHeader";
import Credentials from "./components/sections/Credentials/Credentials";
import HomeBanner from "./components/sections/Home/HomeBanner";
import Footer from "./components/sections/Footer/Footer";
import Map from "./components/sections/Map/Map";

import logo from "./assets/images/IPGlogo.png";
import ScopeOfServices from "./components/sections/ScopeOfServices/ScopeOfServices";
import WhyChooseUs from "./components/sections/WhyChooseUs/WhyChooseUs";

function App() {
  return (
    <div className="App">
      <Helmet>
        <link rel="icon" href={logo} type="image/png"></link>
      </Helmet>
      <HomeBanner />
      <TradingHeader />
      <section className="whychooseUs-components">
        <WhyChooseUs />
      </section>
      <div className="main-sections pt-5">
        <ScopeOfServices />
      </div>
      <Credentials />
      <BrandingHeader />
      <Map />
      <Footer />
    </div>
  );
}

export default App;
